import { useTranslation } from 'cng-web-lib'
import Namespace from '../../../constants/locale/Namespace'
import DashboardKeys from 'src/constants/locale/key/Dashboard'

const DashboardTranslationText = () => {

    const { translate } = useTranslation([
        Namespace.UI_COMPONENT,
        Namespace.DASHBOARD
    ])
    //ehbl
    let ehblManifestTitle = translate(Namespace.DASHBOARD, DashboardKeys.EHBL_MANIFEST_TITLE)
    let ehblManifestBySubmittedDateTitle = translate(Namespace.DASHBOARD, DashboardKeys.EHBL_MANIFEST_BY_SUBMITTED_DATE_TITLE)
    let primaryCCN = translate(Namespace.DASHBOARD, DashboardKeys.PRIMARY_CCN)
    let status = translate(Namespace.DASHBOARD, DashboardKeys.STATUS)
    let portOfDischarge = translate(Namespace.DASHBOARD, DashboardKeys.PORT_OF_DISCHARGE)
    let portOfDestinationExit = translate(Namespace.DASHBOARD, DashboardKeys.PORT_OF_DESTINATION_EXIT)
    let hblStatusReleased = translate(Namespace.DASHBOARD, DashboardKeys.HBL_STATUS_RELEASED)
    let masterReferenceNumber = translate(Namespace.DASHBOARD, DashboardKeys.MASTER_REFERENCE_NUMBER)

    //isf 10
    let isf10Title = translate(Namespace.DASHBOARD, DashboardKeys.ISF10_TITLE)
    let isf10BySubmittedDateTitle = translate(Namespace.DASHBOARD, DashboardKeys.ISF10_BY_SUBMITTED_DATE_TITLE)
    let transactionId = translate(Namespace.DASHBOARD, DashboardKeys.TRANSACTION_ID)
    let importerDocumentNumber = translate(Namespace.DASHBOARD, DashboardKeys.IMPORTER_DOCUMENT_NUMBER)
    let shipmentReferenceNumber = translate(Namespace.DASHBOARD, DashboardKeys.SHIPMENT_REFERENCE_NUMBER)
    let referenceBookingNumber = translate(Namespace.DASHBOARD, DashboardKeys.REFERENCE_BOOKING_NUMBER)
    let seeAllRecords = translate(Namespace.DASHBOARD, DashboardKeys.SEE_ALL_RECORDS)

    //ace ocean
    let aceOceanTitle = translate(Namespace.DASHBOARD, DashboardKeys.ACEOCEAN_TITLE)
    let aceOceanBySubmittedDateTitle = translate(Namespace.DASHBOARD, DashboardKeys.ACEOCEAN_BY_SUBMITTED_DATE_TITLE)
    let scac = translate(Namespace.DASHBOARD, DashboardKeys.SCAC)
    let eta = translate(Namespace.DASHBOARD, DashboardKeys.ETA)
    let vesselName = translate(Namespace.DASHBOARD, DashboardKeys.VESSEL_NAME)
    let voyageNumber = translate(Namespace.DASHBOARD, DashboardKeys.VOYAGE_NUMBER)
    let port = translate(Namespace.DASHBOARD, DashboardKeys.PORT)
    let seeAllManifests = translate(Namespace.DASHBOARD, DashboardKeys.SEE_ALL_MANIFESTS)

    //fda pn
    let fdapnTitle = translate(Namespace.DASHBOARD, DashboardKeys.FDAPN_TITLE)
    let fdapnBySubmittedDateTitle = translate(Namespace.DASHBOARD, DashboardKeys.FDAPN_BY_SUBMITTED_DATE_TITLE)
    let referenceNumber = translate(Namespace.DASHBOARD, DashboardKeys.REFERENCE_NUMBER)
    let entryType = translate(Namespace.DASHBOARD, DashboardKeys.ENTRY_TYPE)
    let billType = translate(Namespace.DASHBOARD, DashboardKeys.BILL_TYPE)
    let arrivalLocation = translate(Namespace.DASHBOARD, DashboardKeys.ARRIVAL_LOCATION)
    let anticipatedArrivalDate = translate(Namespace.DASHBOARD, DashboardKeys.ANTICIPATED_ARRIVAL_DATE)

    //status
    let draft = translate(Namespace.DASHBOARD, DashboardKeys.DRAFT)
    let accepted = translate(Namespace.DASHBOARD, DashboardKeys.ACCEPTED)
    let sent = translate(Namespace.DASHBOARD, DashboardKeys.SENT)
    let rejected = translate(Namespace.DASHBOARD, DashboardKeys.REJECTED)
    let statusNotification = translate(Namespace.DASHBOARD, DashboardKeys.STATUS_NOTIFICATION)
    let cancellationAccepted = translate(Namespace.DASHBOARD, DashboardKeys.CANCELLATION_ACCEPTED)
    let cancellationRejected = translate(Namespace.DASHBOARD, DashboardKeys.CANCELLATION_REJECTED)
    let modificationRejected = translate(Namespace.DASHBOARD, DashboardKeys.MODIFICATION_REJECTED)
    let replaceRejected = translate(Namespace.DASHBOARD, DashboardKeys.REPLACE_REJECTED)

    //entry type
    let entryType01 = translate(Namespace.DASHBOARD, DashboardKeys.ENTRY_TYPE_01)
    let entryType02 = translate(Namespace.DASHBOARD, DashboardKeys.ENTRY_TYPE_02)
    let entryType03 = translate(Namespace.DASHBOARD, DashboardKeys.ENTRY_TYPE_03)
    let entryType07 = translate(Namespace.DASHBOARD, DashboardKeys.ENTRY_TYPE_07)
    let entryType11 = translate(Namespace.DASHBOARD, DashboardKeys.ENTRY_TYPE_11)
    let entryType12 = translate(Namespace.DASHBOARD, DashboardKeys.ENTRY_TYPE_12)
    let entryType21 = translate(Namespace.DASHBOARD, DashboardKeys.ENTRY_TYPE_21)
    let entryType23 = translate(Namespace.DASHBOARD, DashboardKeys.ENTRY_TYPE_23)
    let entryType52 = translate(Namespace.DASHBOARD, DashboardKeys.ENTRY_TYPE_52)
    let entryType61 = translate(Namespace.DASHBOARD, DashboardKeys.ENTRY_TYPE_61)
    let entryType62 = translate(Namespace.DASHBOARD, DashboardKeys.ENTRY_TYPE_62)

    //bill type
    let billTypeM = translate(Namespace.DASHBOARD, DashboardKeys.BILL_TYPE_M)
    let billTypeR = translate(Namespace.DASHBOARD, DashboardKeys.BILL_TYPE_R)
    let billTypeT = translate(Namespace.DASHBOARD, DashboardKeys.BILL_TYPE_T)

    //wacm
    let wacmTitle = translate(Namespace.DASHBOARD, DashboardKeys.WACM_TITLE)
    let wacmBySubmittedDateTitle = translate(Namespace.DASHBOARD, DashboardKeys.WACM_BY_SUBMITTED_DATE_TITLE)
    let messageFunction = translate(Namespace.DASHBOARD, DashboardKeys.MESSAGE_FUNCTION)
    let cargoControlNumber = translate(Namespace.DASHBOARD, DashboardKeys.CARGO_CONTROL_NUMBER)
    let destinationOfficeCode = translate(Namespace.DASHBOARD, DashboardKeys.DESTINATION_OFFICE_CODE)
    let error = translate(Namespace.DASHBOARD, DashboardKeys.ERROR)
    let createdDate = translate(Namespace.DASHBOARD, DashboardKeys.CREATED_DATE)

    //message function
    let msgFunctionAdd = translate(Namespace.DASHBOARD, DashboardKeys.MESSAGE_FUNCTION_ADD)
    let msgFunctionModify = translate(Namespace.DASHBOARD, DashboardKeys.MESSAGE_FUNCTION_MODIFY)
    let msgFunctionCancel = translate(Namespace.DASHBOARD, DashboardKeys.MESSAGE_FUNCTION_CANCEL)

    //wacm status
    let goodsReleased = translate(Namespace.DASHBOARD, DashboardKeys.GOODS_RELEASED)
    let declarationAcceptedGoods = translate(Namespace.DASHBOARD, DashboardKeys.DECLARATION_ACCEPTED_AWAITING_ARRIVAL_OF_GOODS)
    let declarationAcceptedWarnings = translate(Namespace.DASHBOARD, DashboardKeys.DECLARATION_ACCEPTED_WITH_WARNINGS)
    let declarationAcceptedProcessing = translate(Namespace.DASHBOARD, DashboardKeys.DECLARATION_ACCEPTED_AWAITING_CUSTOMS_PROCESSING)
    let messageContentRejected = translate(Namespace.DASHBOARD, DashboardKeys.MESSAGE_CONTENT_REJECTED_WITH_COMMENT)
    let messageContentAccepted = translate(Namespace.DASHBOARD, DashboardKeys.MESSAGE_CONTENT_ACCEPTED)
    let goodsRequiredExamination = translate(Namespace.DASHBOARD, DashboardKeys.GOODS_REQUIRED_FOR_EXAMINATION_REFERRED)
    let goodsMayMove = translate(Namespace.DASHBOARD, DashboardKeys.GOODS_MAY_MOVE_DETAIN_AT_DESTINATION_CFIA)
    let errorMessage = translate(Namespace.DASHBOARD, DashboardKeys.ERROR_MESSAGE)
    let authorisedToDeliver = translate(Namespace.DASHBOARD, DashboardKeys.AUTHORISED_TO_DELIVER_CSA_SHIPMENT)

    //aci air
    let aciAirTitle = translate(Namespace.DASHBOARD, DashboardKeys.ACIAIR_TITLE)
    let aciAirBySubmittedDateTitle = translate(Namespace.DASHBOARD, DashboardKeys.ACIAIR_BY_SUBMITTED_DATE_TITLE)
    let conveyanceRefNo = translate(Namespace.DASHBOARD, DashboardKeys.CONVEYANCE_REFNO)
    let carrierCode = translate(Namespace.DASHBOARD, DashboardKeys.CARRIER_CODE)
    let flightNo = translate(Namespace.DASHBOARD, DashboardKeys.FLIGHT_NO)
    let departurePort = translate(Namespace.DASHBOARD, DashboardKeys.DEPARTURE_PORT)
    let arrivalPort = translate(Namespace.DASHBOARD, DashboardKeys.ARRIVAL_PORT)
    
    //conveyance status
    let conveyanceStatus1 = translate(Namespace.DASHBOARD, DashboardKeys.CONVEYANCE_STATUS_1)
    let conveyanceStatus1048 = translate(Namespace.DASHBOARD, DashboardKeys.CONVEYANCE_STATUS_1048)
    let conveyanceStatus1049 = translate(Namespace.DASHBOARD, DashboardKeys.CONVEYANCE_STATUS_1049)
    let conveyanceStatus17 = translate(Namespace.DASHBOARD, DashboardKeys.CONVEYANCE_STATUS_17)
    let conveyanceStatus200 = translate(Namespace.DASHBOARD, DashboardKeys.CONVEYANCE_STATUS_200)
    let conveyanceStatus25 = translate(Namespace.DASHBOARD, DashboardKeys.CONVEYANCE_STATUS_25)
    let conveyanceStatus14 = translate(Namespace.DASHBOARD, DashboardKeys.CONVEYANCE_STATUS_14)
    let conveyanceStatus28 = translate(Namespace.DASHBOARD, DashboardKeys.CONVEYANCE_STATUS_28)
    let conveyanceStatus29 = translate(Namespace.DASHBOARD, DashboardKeys.CONVEYANCE_STATUS_29)
    let conveyanceStatus20 = translate(Namespace.DASHBOARD, DashboardKeys.CONVEYANCE_STATUS_20)
    let conveyanceStatus21 = translate(Namespace.DASHBOARD, DashboardKeys.CONVEYANCE_STATUS_21)
    let conveyanceStatus22 = translate(Namespace.DASHBOARD, DashboardKeys.CONVEYANCE_STATUS_22)
    let conveyanceStatus32 = translate(Namespace.DASHBOARD, DashboardKeys.CONVEYANCE_STATUS_32)
    let conveyanceStatus33 = translate(Namespace.DASHBOARD, DashboardKeys.CONVEYANCE_STATUS_33)
    
    //aci ocean
    let aciOceanTitle = translate(Namespace.DASHBOARD, DashboardKeys.ACIOCEAN_TITLE)
    let aciOceanBySubmittedDateTitle = translate(Namespace.DASHBOARD, DashboardKeys.ACIOCEAN_BY_SUBMITTED_DATE_TITLE)
    let aciOceanFormType = translate(Namespace.DASHBOARD, DashboardKeys.ACI_OCEAN_FORM_TYPE)
    let aciOceanDocTypeImport = translate(Namespace.DASHBOARD, DashboardKeys.ACI_OCEAN_DOC_TYPE_IMPORT)
    let aciOceanDocTypeExport = translate(Namespace.DASHBOARD, DashboardKeys.ACI_OCEAN_DOC_TYPE_EXPORT)
    let aciOceanDocTypeEmpty = translate(Namespace.DASHBOARD, DashboardKeys.ACI_OCEAN_DOC_TYPE_EMPTY)
    let aciOceanDocTypeSupplementary = translate(Namespace.DASHBOARD, DashboardKeys.ACI_OCEAN_DOC_TYPE_SUPPLEMENTARY)
    let aciOceanCcn = translate(Namespace.DASHBOARD, DashboardKeys.ACI_OCEAN_CCN)
    let aciOceanCustomsProcedure = translate(Namespace.DASHBOARD, DashboardKeys.ACI_OCEAN_CUSTOMS_PROCEDURE)
    let aciOceanCustomsProcedureInTransit = translate(Namespace.DASHBOARD, DashboardKeys.ACI_OCEAN_CUSTOMS_PROCEDURE_IN_TRANSIT)
    let aciOceanCustomsProcedureImportedGoods = translate(Namespace.DASHBOARD, DashboardKeys.ACI_OCEAN_CUSTOMS_PROCEDURE_IMPORTED_GOODS)
    let aciOceanCustomsProcedureExportedGoods = translate(Namespace.DASHBOARD, DashboardKeys.ACI_OCEAN_CUSTOMS_PROCEDURE_EXPORTED_GOODS)
    let aciOceanCustomsProcedureFrob = translate(Namespace.DASHBOARD, DashboardKeys.ACI_OCEAN_CUSTOMS_PROCEDURE_FROB)
    let aciOceanMessageFunction = translate(Namespace.DASHBOARD, DashboardKeys.ACI_OCEAN_MESSAGE_FUNCTION)
    let aciOceanMsgFunctionOriginal = translate(Namespace.DASHBOARD, DashboardKeys.ACI_OCEAN_MSG_FUNCTION_ORIGINAL)
    let aciOceanMsgFunctionChange = translate(Namespace.DASHBOARD, DashboardKeys.ACI_OCEAN_MSG_FUNCTION_CHANGE)
    let aciOceanMsgFunctionCancel = translate(Namespace.DASHBOARD, DashboardKeys.ACI_OCEAN_MSG_FUNCTION_CANCEL)
    let aciOceanCreatedDate = translate(Namespace.DASHBOARD, DashboardKeys.ACI_OCEAN_CREATED_DATE)

    //aes
    let aesTitle = translate(Namespace.DASHBOARD, DashboardKeys.AES_TITLE)
    let aesBySubmittedDateTitle = translate(Namespace.DASHBOARD, DashboardKeys.AES_BY_SUBMITTED_DATE_TITLE)
    let shipperName = translate(Namespace.DASHBOARD, DashboardKeys.SHIPPER_NAME)
    let consigneeName = translate(Namespace.DASHBOARD, DashboardKeys.CONSIGNEE_NAME)
    let entryNumber = translate(Namespace.DASHBOARD, DashboardKeys.ENTRY_NUMBER)
    let cbpItnNo = translate(Namespace.DASHBOARD, DashboardKeys.CBP_ITN_NO)

    return {
        ehblManifestTitle,
        ehblManifestBySubmittedDateTitle,
        primaryCCN,
        status,
        portOfDischarge,
        portOfDestinationExit,
        hblStatusReleased,
        masterReferenceNumber,
        draft,
        accepted,
        sent,
        rejected,
        statusNotification,
        cancellationAccepted,
        cancellationRejected,
        modificationRejected,
        replaceRejected,
        isf10Title,
        isf10BySubmittedDateTitle,
        transactionId,
        importerDocumentNumber,
        shipmentReferenceNumber,
        referenceBookingNumber,
        seeAllRecords,
        aceOceanTitle,
        aceOceanBySubmittedDateTitle,
        scac,
        eta,
        vesselName,
        voyageNumber,
        port,
        seeAllManifests,
        fdapnTitle,
        fdapnBySubmittedDateTitle,
        referenceNumber,
        entryType,
        billType,
        arrivalLocation,
        anticipatedArrivalDate,
        entryType01,
        entryType02,
        entryType03,
        entryType07,
        entryType11,
        entryType12,
        entryType21,
        entryType23,
        entryType52,
        entryType61,
        entryType62,
        billTypeM,
        billTypeR,
        billTypeT,
        wacmTitle,
        wacmBySubmittedDateTitle,
        messageFunction,
        cargoControlNumber,
        destinationOfficeCode,
        error,
        msgFunctionAdd,
        msgFunctionModify,
        msgFunctionCancel,
        createdDate,
        goodsReleased,
        declarationAcceptedGoods,
        declarationAcceptedWarnings,
        declarationAcceptedProcessing,
        messageContentRejected,
        messageContentAccepted,
        goodsRequiredExamination,
        goodsMayMove,
        errorMessage,
        authorisedToDeliver,
        aciAirTitle,
        aciAirBySubmittedDateTitle,
        conveyanceRefNo,
        carrierCode,
        flightNo,
        departurePort,
        arrivalPort,
        conveyanceStatus1,
        conveyanceStatus1048,
        conveyanceStatus1049,
        conveyanceStatus17,
        conveyanceStatus200,
        conveyanceStatus25,
        conveyanceStatus14,
        conveyanceStatus28,
        conveyanceStatus29,
        conveyanceStatus20,
        conveyanceStatus21,
        conveyanceStatus22,
        conveyanceStatus32,
        conveyanceStatus33,
        aesTitle,
        aesBySubmittedDateTitle,
        shipperName,
        consigneeName,
        entryNumber,
        cbpItnNo,
        aciOceanTitle,
        aciOceanBySubmittedDateTitle,
        aciOceanFormType,
        aciOceanDocTypeImport,
        aciOceanDocTypeExport,
        aciOceanDocTypeEmpty,
        aciOceanDocTypeSupplementary,
        aciOceanCcn,
        aciOceanCustomsProcedure,
        aciOceanCustomsProcedureInTransit,
        aciOceanCustomsProcedureImportedGoods,
        aciOceanCustomsProcedureExportedGoods,
        aciOceanCustomsProcedureFrob,
        aciOceanMessageFunction,
        aciOceanMsgFunctionOriginal,
        aciOceanMsgFunctionChange,
        aciOceanMsgFunctionCancel,
        aciOceanCreatedDate
    }
}

export default DashboardTranslationText